import { AssetConfigContext } from 'contexts/assetConfig.context';
import React, { createContext, ReactNode, useContext, useRef, useState } from 'react';
import {
  getArrayOfValuesFromAssetStatusOptions,
  getArrayOfValuesFromOptions,
} from '../utils/utils';
import { AssetStatesContext } from 'contexts/assetStates.context';
export type searchTypeType = 'assets' | 'users' | 'none';

type SearchFilterTypes = {
  doNotCalculateFloor: boolean;
  setDoNotCalculateFloor: (arg: boolean) => void;
  inSearchMode: boolean;
  setInSearchMode: (arg: boolean) => void;
  inFilterMode: boolean;
  setInFilterMode: (arg: boolean) => void;
  searchAPIcallInProgress: boolean;
  setSearchAPIcallInProgress: (arg: boolean) => void;
  searchTerm: string;
  setSearchTerm: (arg: string) => void;
  searchType: searchTypeType;
  setSearchType: (arg: searchTypeType) => void;
  assetOwnerCheckedListArray: [] | string[];
  setAssetOwnerCheckedListArray: (value: string[] | []) => void;
  assetSubtypeCheckedListArray: [] | string[];
  setAssetSubtypeCheckedListArray: (value: string[] | []) => void;
  assetStatusCheckedListArray: [] | string[];
  setAssetStatusCheckedListArray: (value: string[] | []) => void;
  setAssetSubtypeCheckAll: (arg: boolean) => void;
  setAssetOwnerCheckAll: (arg: boolean) => void;
  assetSubtypeCheckAll: boolean;
  assetOwnerCheckAll: boolean;
  defaultAssetStatusCheckedListArray: [] | string[];
  assetStatusCheckAll: boolean;
  setAssetStatusCheckAll: (arg: boolean) => void;
  hasSearchTerm: boolean;
  menuIsOpen: boolean;
  setMenuIsOpen: (arg: boolean) => void;
  filtersModified: boolean;
  setFiltersModified: (arg: boolean) => void;
  defaultAssetOwnerCheckedListArray: string[];
  defaultAssetSubtypeCheckedListArray: string[];
  showAssetsPeopleSelectedCheckboxArrayCachedRef: any;
  cachedEstimateRef: any;
  assetOwnerCheckedListArrayRef: any;
  assetSubtypeCheckedListArrayRef: any;
  assetStatusCheckedListArrayRef: any;
};

export const SearchFilterContext = createContext({} as SearchFilterTypes);

type SearchFilterProviderProps = { children: ReactNode };

// A context that stores search and filter params for them to be used by polling components.
const SearchFilterProvider = ({ children }: SearchFilterProviderProps) => {
  const { assetOwners, assetSubtype } = useContext(AssetConfigContext);
  const { availableAssetStates } = useContext(AssetStatesContext);

  const [searchType, setSearchType] = useState<searchTypeType>('none');

  //booleans
  const [doNotCalculateFloor, setDoNotCalculateFloor] = useState(false);
  const [inSearchMode, setInSearchMode] = useState(false);
  const [inFilterMode, setInFilterMode] = useState(false);
  const [searchAPIcallInProgress, setSearchAPIcallInProgress] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [filtersModified, setFiltersModified] = useState(false);

  const [assetOwnerCheckedListArray, setAssetOwnerCheckedListArray] = useState<string[] | []>([]);
  const [assetSubtypeCheckedListArray, setAssetSubtypeCheckedListArray] = useState<string[] | []>(
    [],
  );
  const [assetStatusCheckedListArray, setAssetStatusCheckedListArray] = useState<string[] | []>([]);

  const defaultAssetOwnerCheckedListArray = getArrayOfValuesFromOptions(assetOwners);
  const defaultAssetSubtypeCheckedListArray = getArrayOfValuesFromOptions(assetSubtype);
  const defaultAssetStatusCheckedListArray =
    getArrayOfValuesFromAssetStatusOptions(availableAssetStates);

  const [assetStatusCheckAll, setAssetStatusCheckAll] = useState(true);
  const [assetSubtypeCheckAll, setAssetSubtypeCheckAll] = useState(true);
  const [assetOwnerCheckAll, setAssetOwnerCheckAll] = useState(true);
  const showAssetsPeopleSelectedCheckboxArrayCachedRef = useRef(null);

  const cachedEstimateRef = useRef(null); // for comparing single assets returned from search results.
  const assetOwnerCheckedListArrayRef: any = useRef(null);
  const assetSubtypeCheckedListArrayRef: any = useRef(null);
  const assetStatusCheckedListArrayRef: any = useRef(null);

  const hasSearchTerm = searchTerm.length > 0;
  const value: SearchFilterTypes = {
    searchType,
    setSearchType,
    doNotCalculateFloor,
    setDoNotCalculateFloor,
    inSearchMode,
    setInSearchMode,
    inFilterMode,
    setInFilterMode,
    searchAPIcallInProgress,
    setSearchAPIcallInProgress,
    searchTerm,
    setSearchTerm,
    assetOwnerCheckedListArray,
    setAssetOwnerCheckedListArray,
    assetSubtypeCheckedListArray,
    setAssetSubtypeCheckedListArray,
    assetStatusCheckedListArray,
    setAssetStatusCheckedListArray,
    assetSubtypeCheckAll,
    setAssetSubtypeCheckAll,
    assetOwnerCheckAll,
    setAssetOwnerCheckAll,
    defaultAssetStatusCheckedListArray,
    assetStatusCheckAll,
    setAssetStatusCheckAll,
    hasSearchTerm,
    menuIsOpen,
    setMenuIsOpen,
    filtersModified,
    setFiltersModified,
    defaultAssetOwnerCheckedListArray,
    defaultAssetSubtypeCheckedListArray,
    showAssetsPeopleSelectedCheckboxArrayCachedRef,
    cachedEstimateRef,
    assetOwnerCheckedListArrayRef,
    assetSubtypeCheckedListArrayRef,
    assetStatusCheckedListArrayRef,
  };

  return <SearchFilterContext.Provider value={value}>{children}</SearchFilterContext.Provider>;
};

export default SearchFilterProvider;
